// src/pages/FeeManagement.js
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import colors from "../Constants/colors";

const FeeManagement = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardStyle = {
    background: "#ffffff",
    padding: "20px",
    borderRadius: "14px",
    boxShadow: `0 4px 12px ${colors.cardShadow}`,
    display: "flex",
    alignItems: "center",
    gap: "16px",
    minHeight: "120px",
    transition: "0.3s",
  };

  const iconStyle = {
    fontSize: "36px",
    flexShrink: 0,
  };

  const heading = {
    fontSize: "18px",
    fontWeight: "600",
    color: colors.grayDark,
    marginBottom: "4px",
  };

  const subText = {
    fontSize: "12px",
    color: colors.grayDark,
    opacity: 0.85,
  };

  const titleStyle = {
    fontWeight: "700",
    color: colors.grayDark,
  };

  const feeCards = [
    {
      title: "Pending Fee Report",
      description: "View pending fees for your class.",
      icon: "fa-exclamation-circle",
      color: "#EF4444",
      link: "/fee-report",
    },
  ];

  return (
    <div className="bg-white min-h-screen p-6">
      <div className="max-w-7xl mx-auto">


        <div
          className={`grid gap-6 ${
            isMobile ? "grid-cols-1" : "sm:grid-cols-2 lg:grid-cols-3"
          }`}
        >
          {feeCards.map((fee, idx) => (
            <Link to={fee.link} key={idx}>
              <div style={cardStyle} className="hover:scale-[1.02] transition">
                <i
                  className={`fas ${fee.icon}`}
                  style={{
                    ...iconStyle,
                    color: fee.color,
                  }}
                ></i>

                <div>
                  <h2 style={heading}>{fee.title}</h2>
                  <p style={subText}>{fee.description}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>

      </div>
    </div>
  );
};

export default FeeManagement;
